<template>


   <div  v-show="this.$store.state.isShowModal"  class="box">

    <div id="bp-left" class="box-part" v-if="this.$store.state.lang==='cn'">
        <div id="partition-register" class="partition">
            <div class="partition-title">登記資料</div> 
            <div class="partition-form"><form autocomplete="false">
                 <input  v-model="name" id="n-name" @input="bullshite($event)" name="name"  type="text" placeholder="稱呼"> 
                <p v-html="form_name_error_mes"></p>
                <input  v-model="email" id="n-email" @input="bullshite($event)" name="email"  type="text" placeholder="電郵"> 
                <p v-html="form_email_error_mes"></p>
                <input  v-model="mobile" id="n-mobile" @input="bullshite($event)" name="mobile" type="number" placeholder="聯繫電話"> 
                <p v-html="form_mobile_error_mes"></p>
                </form> 
                <div  v-html="feedback"></div> <div class="button-set">
                 <button @click="bullshite('commit')" name="commit" id="goto-signin-btn">確認</button>
                 <button @click="cancel"  id="register-btn">取消</button></div>
                 
            </div>
        </div>
    </div>


<div id="bp-left" class="box-part"  v-else>
        <div id="partition-register" class="partition">
            <div class="partition-title">登记资料</div> 
            <div class="partition-form"><form autocomplete="false">
                 <input  v-model="name" id="n-name" @input="bullshite($event)" name="name"  type="text" placeholder="称呼"> 
                <p v-html="form_name_error_mes"></p>
                <input  v-model="email" id="n-email" @input="bullshite($event)" name="email"  type="text" placeholder="电邮"> 
                <p v-html="form_email_error_mes"></p>
                <input  v-model="mobile" id="n-mobile" @input="bullshite($event)" name="mobile" type="number" placeholder="联系电话"> 
                <p v-html="form_mobile_error_mes"></p>
                </form> 
                <div  v-html="feedback"></div> <div class="button-set">
                 <button @click="bullshite('commit')" name="commit" id="goto-signin-btn">确认</button>
                 <button @click="cancel"  id="register-btn">取消</button></div>
                 
            </div>
        </div>
    </div>


        

    </div>

    <div  v-show="this.$store.state.isShowModal"  @click="hide" class="mask"></div>
</template>
<script>


import axios from 'axios'


export default {
  name: 'DiyModal',
  data () {
      return {
isShow:true,
email:'',
mobile:'',
name:'',
form_email_error_mes:'',
form_mobile_error_mes:'',
form_name_error_mes:'',
 mail_api:'http://47.242.226.213:8081/mailSend'
,feedback:''

      }
  },
    methods: {

        bullshite(e){

    this.feedback=''

      const current_target = e!=='commit'?e.target.getAttribute("name"):e
      console.log(current_target)

 if(current_target==='name' || current_target==='commit'){
      if(this.name===''){
       
        this.form_name_error_mes =  (this.$store.state.lang==='cn'?'稱呼不能爲空':'称呼不能为空')
        return
      }else{
        this.form_name_error_mes = ''
        
      }
    }


    if(current_target==='email' || current_target==='commit'){
      if(this.email===''){
       
        this.form_email_error_mes =  (this.$store.state.lang==='cn'?'電郵不能爲空':'电邮不能为空')
        return
      }else{
        this.form_email_error_mes = ''
        
      }
    }


        if(current_target==='mobile' || current_target==='commit'){
      if(this.mobile===''){
       
        this.form_mobile_error_mes =  (this.$store.state.lang==='cn'?'聯繫電話不能爲空':'联系电话不能为空')
        return
      }else{
        this.form_mobile_error_mes = ''
        
      }
    }


    if(current_target==='commit'){
           this.$store.state.isLoading = true


       setTimeout(() => {
           const req_json = { 
                subject : "Tiffany website feedback",
                 text:"Tiffany website feedback",
                html : 'Customer feedback form email:'+this.name+this.email +',mobile:' + this.mobile  }
                axios.get(this.mail_api,{params:req_json}).then((response) => {
        console.log(response.data)
        this.$store.state.isLoading = false
        if(response.data.code===101){
            this.feedback =  (this.$store.state.lang==='cn'?'郵件提交成功':'邮件提交成功')
              this.download()
         
        }else{
         this.feedback = (this.$store.state.lang==='cn'?'郵件提交失敗':'邮件提交失败')
        }
        
      }) 
      },2000)



      
}


        },
        show () {
            this.$data.isShow = true;
        },
        hide () {
            this.$store.state.isShowModal = false
        },
        download(){
           // console.log('down:'+this.$store.state.download)
            const down = this.$store.state.download

             var el = document.createElement("a");
				document.body.appendChild(el);
				el.href = down; //url 是你得到的连接
				el.target = '_new'; //指定在新窗口打开
				el.click();
				document.body.removeChild(el);

        },
        cancel(){
    this.name=''
    this.email=''
    this.mobile=''        
    this.feedback=''
     this.$store.state.isShowModal = false
        }

    }
}





</script>


<style scoped>


.box .partition .partition-title {
    box-sizing: border-box;
    padding: 30px;
    width: 100%;
    text-align: center;
    letter-spacing: 1px;
    font-size: 20px;
    font-weight: 300;
}
.box{
    width:80%;
     height: 80%;   
position:absolute;
z-index: 99999;
background: #fff;

top:10%;
bottom:10%;
left: 10%;
right: 10%;
    
}

 .box p{
     color:red
 }

.box .github-btn {
    border-color: #dba226;
    color: #dba226;
}
 .box .box-part {
    display: inline-block;
    position: relative;
    vertical-align: top;
    height: 100%;
   
}
.box .facebook-btn {
    border-color: #3880ff;
    color: #3880ff;
}
 .box input[type=text],.box input[type=number] {
    display: block;
    box-sizing: border-box;
    margin-bottom: 4px;
    width: 100%;
    font-size: 12px;
    line-height: 2;
    border: 0;
    border-bottom: 1px solid #dddedf;
    padding: 4px 8px;
    font-family: inherit;
    transition: all .5s;
    outline: none;
}
.box .large-btn {
    width: 100%;
    background: #fff;
}
.box button {
    background: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 10px;
    letter-spacing: 1px;
    font-family: Open Sans,sans-serif;
    font-weight: 400;
    /* min-width: 140px; */
    margin-top: 8px;
    color: #8b8c8d;
    cursor: pointer;
    border: 1px solid #dddedf;
    text-transform: uppercase;
    transition: all .1s;
    font-size: 10px;
    outline: none;
}

.box .partition .partition-form {
    padding: 0 20px;
    box-sizing: border-box;
}.box .button-set {
    margin-bottom: 8px;
}
.box #register-btn, .box #signin-btn {
    margin-left: 8px;
}



</style>


<!-- media -->
<style scoped>
@media   (min-width:1024px){
    
    .box input[type=text]{
        width:250px
    }

    .box button{
        width:100px ;
    }

    .box{
        width: 30%;
        
        left: 35%;
    right: 35%;
    }


    .box button{
       
        background: #846C32;
        color: #FFFFFF;
        border-radius:31px
    }

}



@media screen and (max-width: 767px), screen and (max-height: 400px){
     .box input[type=text]{
        width:220px
    }

    .box button{
        width:100px ;
        background: #846C32;
        color: #FFFFFF;
        border-radius:31px
    }
}




</style>